import Vue from 'vue'
import api from '../../api'
import award from "@/components/fields/Award.vue";

const SET_CATEGORIES = 'SET_CATEGORIES'
const SET_INDICATORS = 'SET_INDICATORS'
const ADD_INDICATOR = 'ADD_INDICATOR'
const SET_FIELDS = 'SET_FIELDS'
const ADD_FIELD = 'ADD_FIELD'
const SET_VALUES = 'SET_VALUES'
const SET_VALUES_ALL = 'SET_VALUES_ALL'
const ADD_VALUE = 'ADD_VALUE'
const DEL_VALUE = 'DEL_VALUE'
const SET_PLANNED_VALUE = 'SET_PLANNED_VALUE'
const SET_INDICATOR_AWARD = 'SET_INDICATOR_AWARD'

export default {
  namespaced: true,
  state: {
    categories: {},
    indicators: {},
    values: {},
    valuesAll: {},
    fieldTypes: {
      string: 'Строка',
      text: 'Текст',
      integer: 'Целое',
      float: 'Дробное',
      date: 'Дата',
      datetime: 'Дата + Время',
      enum: 'Список',
      award: 'Значение индикатора',
      file: 'Файлы',
    },
  },
  getters: {
    getIndicators(state) {
      return state.indicators
    },
    getCategories(state) {
      return state.categories
    }
  },
  mutations: {
    [SET_CATEGORIES]: (state, categories) => {
      state.categories = categories
    },
    [SET_INDICATORS]: (state, indicators) => {
      state.indicators = indicators
    },
    [ADD_INDICATOR]: (state, indicator) => {
      if (!indicator.parent) {
        state.indicators = Object.assign({}, state.indicators, {[indicator.id]: indicator})
      } else {
        const children = Object.assign({}, state.indicators[indicator.parent].children, {[indicator.id]: indicator})
        state.indicators[indicator.parent] = Object.assign({}, state.indicators[indicator.parent], {children})
      }

    },
    [SET_INDICATOR_AWARD]: (state, {indicator, award}) => {
      if (indicator.parent) {
        Vue.set(state.indicators[indicator.parent].children[indicator.id], 'award', award)
      } else {
        Vue.set(state.indicators[indicator.id], 'award', award)
      }
    },
    [SET_FIELDS]: (state, {indicator, fields}) => {
      fields = ((fields instanceof Array) && (fields.length === 0)) ? {} : fields
      if (!indicator.parent) {
        state.indicators[indicator.id].fields = fields
      } else {
        state.indicators[indicator.parent].children[indicator.id].fields = fields
      }
    },
    [ADD_FIELD]: (state, {indicator, field}) => {
      if (!indicator.parent) {
        let _indicator = state.indicators[indicator.id]
        _indicator.fields = Object.assign({}, _indicator.fields, {[field.id]: field})
        state.indicators[indicator.id] = Object.assign({}, _indicator)
      } else {
        let _indicator = state.indicators[indicator.parent].children[indicator.id]
        _indicator.fields = Object.assign({}, _indicator.fields, {[field.id]: field})
        state.indicators[indicator.parent].children[indicator.id] = Object.assign({}, _indicator)
      }
    },
    [SET_VALUES]: (state, {period, values}) => {
      if (!state.values[period.id]) {
        Vue.set(state.values, period.id, {})
      }
      Object.keys(values).forEach((key) => {
        Vue.set(state.values[period.id], key, values[key])
      })
    },
    [SET_VALUES_ALL]: (state, {period, teacher, values}) => {
      if (!state.valuesAll[period.id]) {
        Vue.set(state.valuesAll, period.id, {})
      }
      if (!state.valuesAll[period.id][teacher]) {
        Vue.set(state.valuesAll[period.id], teacher, {})
      }
      Object.keys(values).forEach((key) => {
        Vue.set(state.valuesAll[period.id][teacher], key, values[key])
      })
    },
    [ADD_VALUE]: (state, {period, indicator, value}) => {
      Vue.set(state.values[period][indicator.id].values, value.id, value)
    },
    [DEL_VALUE]: (state, {period, indicator, value}) => {
      Vue.delete(state.values[period][indicator.id].values[value.id])
    },
    [SET_PLANNED_VALUE]: (state, {period, indicator, plannedValue}) => {
      Vue.set(state.values[period][indicator.id], 'plan', plannedValue)
    }
  },
  actions: {
    getIndicators: async ({commit}, period) => {
      let response = await api.indicators.list(period)
      if (response.success) {
        commit(SET_CATEGORIES, response.categories)
        commit(SET_INDICATORS, response.indicators)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка индикаторов')
      }
    },
    loadIndicators: async ({commit}, period) => {
      let response = await api.indicators.list(period)
      if (response.success) {
        commit(SET_CATEGORIES, response.categories)
        commit(SET_INDICATORS, response.indicators)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка индикаторов')
      }
    },
    saveIndicator: async ({commit}, { indicator, period }) => {
      let response = await api.indicators.save(indicator, period)
      if (response.success) {
        commit(ADD_INDICATOR, response.indicator)
      } else {
        throw new Error(response.message || 'Произошла ошибка при сохранении индикатора')
      }
    },
    getFieldsForIndicator: async ({commit}, indicator) => {
      let response = await api.indicators.fields(indicator.id)
      if (response.success) {
        commit(SET_FIELDS, {indicator, fields: response.fields})
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка полей')
      }
    },
    saveField: async ({commit}, {indicator, field}) => {
      let response = await api.indicators.saveField(indicator, field)
      if (response.success) {
        commit(ADD_FIELD, {indicator, field: response.field})
      } else {
        throw new Error(response.message || 'Произошла ошибка при сохранении поля')
      }
    },

    getValues: async ({commit}, {period, indicator}) => {
      let response = await api.plan.values(period, indicator)
      if (response.success) {
        commit(SET_VALUES, {period, values: response.values})
      } else {
        throw new Error(response.message || 'Произошла ошибка при получении значений индикативного плана')
      }
    },
    getTeacherValues: async ({commit}, {period, teacher}) => {
      let response = await api.plan.valuesForTeacher(period, teacher)
      if (response.success) {
        commit(SET_VALUES_ALL, {period, teacher, values: response.values})
      } else {
        throw new Error(response.message || 'Произошла ошибка при получении значений индикативного плана')
      }
    },
    saveValue: async ({commit}, value) => {
      let response = await api.plan.saveValue(value)
      if (response.success) {
        commit(ADD_VALUE, {period: value.period, indicator: value.indicator, value: response.value})
      } else {
        throw new Error(response.message || 'Произошла ошибка при сохранении значения индикативного плана')
      }
    },
    deleteValue: async ({commit}, {period, indicator, value}) => {
      let response = await api.plan.deleteValue(period, indicator, value)
      if (response.success) {
        commit(DEL_VALUE, {period, indicator, value})
      } else {
        throw new Error(response.message || 'Произошла ошибка при удалении значения индикативного плана')
      }
    },
    countValue: async ({commit}, {period, indicator, value, award, comment}) => {
      let response = await api.plan.countValue(period, indicator, value, award, comment)
      if (response.success) {
        //
      } else {
        throw new Error(response.message || 'Произошла ошибка при удалении значения индикативного плана')
      }
    },
    uploadDocument: async ({commit}, {file, progress, indicatorValue, indicatorField}) => {
      let response = await api.documents.upload(file, progress, indicatorValue, indicatorField)
      if (response.success) {
        return response.document
      } else {
        switch (response.code) {
          case 'size_limit_exceeded':
            throw new Error('Слишком большой размер файла!')
          case 'unknown_mime':
            throw new Error('Не поддерживаемый тип файла!')
          default:
            throw new Error(response.message || 'Произошла ошибка при загрузке файла')
        }
      }
    },
    deleteDocument: async ({commit}, file) => {
      let response = await api.documents.delete(file)
      if (response.success) {
        return true
      } else {
        throw new Error(response.message || 'Произошла ошибка при удалении файла')
      }
    },
    getDocumentURL: async ({commit}, file) => {
      let response = await api.documents.url(file)
      if (response.success) {
        return response.url
      } else {
        throw new Error(response.message || 'Произошла ошибка при получении URL файла')
      }
    },
    saveAward: async ({commit}, {period, indicator, award}) => {
      let response = await api.indicators.saveAward(period, indicator, award)
      if (response.success) {
        commit(SET_INDICATOR_AWARD, {period, indicator, award})
      } else {
        throw new Error(response.message || 'Произошла ошибка при сохранении значения')
      }
    },
    savePlan: async ({commit}, {period, indicator, plannedValue}) => {
      let response = await api.plan.savePlannedValue(period, indicator, plannedValue)
      if (response.success) {
        commit(SET_PLANNED_VALUE, {period, indicator, plannedValue})
      } else {
        throw new Error(response.message || 'Произошла ошибка при сохранении планового значения')
      }
    }
  }
}
